import React from 'react';
import Draggable from 'react-draggable';
import ModalDialog from 'react-bootstrap/ModalDialog';
import { isMobileViewport } from '../../utils/mobileUtil';

// Drag only by the header, and never when the pointer starts on a control.
// react-draggable calls preventDefault on touchstart, which on a touch screen
// swallows the tap on the close button and stops the modal body from scrolling.
const DRAG_HANDLE = '.modal-header';
const DRAG_CANCEL = 'button, a, input, select, textarea, .close';

function DraggableModalDialog({ nodeRef, ...props }) {
  return (
    <Draggable
      nodeRef={nodeRef}
      handle={DRAG_HANDLE}
      cancel={DRAG_CANCEL}
      disabled={isMobileViewport()}
    >
      <div>
        <ModalDialog {...props} />
      </div>
    </Draggable>
  );
}

export default DraggableModalDialog;
